<template>
  <div id="about">
    <v-container>
      <v-row class="mb-13 pb-13">
        <v-col
          cols="12"
          lg="4"
          :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : 'text-left'"
        >
          <h1 class="primary300--text mb-2">
            How It Works
          </h1>
          <p>
            ResearchHUB is led by Abu Dhabi's Advanced Technology Research Council (ATRC), working
            in conjunction with top higher education institutes, research centers, and government
            agencies in UAE. It serves as a gateway to research facilities and resources provided by
            participating entities, enhancing the potential for innovative research and optimizing
            the utilization of existing research resources in UAE. ResearchHUB provides a
            streamlined, user-friendly platform that allows users to effortlessly browse and search
            for services. Learn about the Guiding Principles and administrative policies of the Open
            Science initiative by visiting the link below:
          </p>
          <!-- <p>
            ResearchHUB is a collaborative effort led by Abu Dhabi's Advanced Technology Research
            Council (ATRC), working in conjunction with top universities, higher education
            institutes, research centers, and government agencies in UAE. It serves as a gateway to
            research facilities and resources provided by participating entities, enhancing the
            potential for innovative research and optimizing the utilization of government-funded
            and other research resources in UAE.
          </p>
          <p>
            ResearchHUB provides a streamlined, user-friendly platform that allows users to
            effortlessly browse and search for services. Registered visitors enjoy advanced
            features, such as filtering options, to tailor their searches
          </p>
          <p>
            Explore our Catalogue and Marketplace today.
          </p>
          <p>
            Learn about the Guiding Principles and administrative policies of the Open Science
            initiative by visiting the link below:
          </p> -->
          <p>
            <GuidelinesModal />
          </p>
          <!-- <v-btn
            color="neutral"
            dark
            class="mt-16 text-bold pl-16 pr-16 pt-9 pb-9 white--text"
            x-large
            :to="{ name: 'PublicMarketplace' }"
          >
            Go to Catalogue & Marketplace
          </v-btn> -->
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          lg="6"
          class="text-right "
          :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : 'text-right'"
        >
          <div class="image-wrapper">
            <img
              :src="require('@/assets/img/landing-page/pages/how_it_works.jpg')"
              alt="About Us Image"
            />
            <div class="overlay"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import GuidelinesModal from '@/components/landing-page/policies/GuidelinesModal.vue';
export default {
  name: 'HowItWorks',
  components: { GuidelinesModal },
  mounted() {
    //this.$vuetify.goTo(1, {});
  },
};
</script>

<style scoped>
.image-wrapper {
  position: relative;
  display: inline-block;
}

.image-wrapper img {
  display: block;
  width: 700px;
  height: auto;
  border-radius: 24px;
}

@media (max-width: 768px) {
  .image-wrapper img {
    width: 100%;
    max-width: 100%;
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(100, 0, 255, 0.2);
  z-index: 0;
  pointer-events: none;
  border-radius: 24px;
}
</style>
